import { Controller } from '@hotwired/stimulus'

interface EventWithParams extends Event {
  params: {
    action: string
  }
}

export class FormActionsController extends Controller<HTMLFormElement> {
  static targets = ['click']

  declare readonly clickTargets: HTMLButtonElement[]

  triggerAction({ params }: EventWithParams) {
    const { action } = params
    const target = document.querySelector(action) as HTMLButtonElement | null

    target?.click()
  }
}
